var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":_vm.$t('broadcastEditor.cardTitle'),"description":_vm.$t('broadcastEditor.cardDescription'),"to":{ name: _vm.RouteName.General }}},[_c('template',{slot:"content"},[_c('BroadcastManager')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }